/* eslint-disable camelcase */
import { useReducer } from 'react';
import { v4 } from 'uuid';

import { ACTIONS } from 'hb-react/shared/apps/Events/constants/actions';
import type { User } from 'hb-react/types';

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.CREATE:
      return [...state, { guest_id: v4(), ...payload.guest }];

    case ACTIONS.DELETE:
      return state.filter(
        ({ guest_id }) => guest_id !== payload.guest.guest_id,
      );

    case ACTIONS.UPDATE: {
      const { guest } = payload;

      const index = state.findIndex(
        ({ guest_id }) => guest_id === guest.guest_id,
      );

      if (index === -1) {
        return state;
      }

      return [
        ...state.slice(0, index),
        { ...state[index], ...guest },
        ...state.slice(index + 1),
      ];
    }

    case ACTIONS.SAVE: {
      return (payload.guests || []).map((guest) => ({
        ...guest,
        ...(state.find(({ guest_id }) => guest_id === guest.guest_id) || {}),
      }));
    }
    default:
      throw new Error('Unsupported method');
  }
};

export const useGuestsReducer = ({
  currentUser,
}: {
  currentUser: User | null;
}) => {
  const initialState = () =>
    (currentUser?.event_guests?.guests || []).map((guest) => ({
      guest_id: guest?.id || v4(),
      ...guest,
    }));

  const [state, dispatch] = useReducer(reducer, [], initialState);

  return {
    guests: state,
    dispatch,
  };
};
